import Axios from 'axios'

const baseURL = import.meta.env.BASE_URL ?? '/'

const axios = Axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
})

export default axios
